import React, { useEffect } from 'react';
import { Box, Preloader } from '@common-fe/common-fe';

import useConvertPdfToPng from '@/utils/hooks/useConvertPdfToPng';

import { ImgSquare } from '../ScanPreview.styles';

interface Props {
  url?: string;
  alt?: string;
  testId?: string;
  onPasswordProtectedChange?: (isPasswordProtected: boolean) => void;
}

const PdfThumb: React.FC<Props> = ({ url, alt, testId = '', onPasswordProtectedChange }) => {
  const { pngDocuments, isLoading, isPasswordProtected } = useConvertPdfToPng({ url });
  const firstImage = pngDocuments?.[0];

  useEffect(() => {
    onPasswordProtectedChange?.(isPasswordProtected);
  }, [isPasswordProtected, onPasswordProtectedChange]);

  if (isLoading) {
    return (
      <Box data-testId={`${testId}_loading`} height="60px" justify="center" align="center">
        <Preloader testId="pdf-thumb-preloader" />
      </Box>
    );
  }

  if (isPasswordProtected) {
    return null;
  }

  return <ImgSquare data-testId={testId} src={firstImage?.link} alt={alt} />;
};

export default PdfThumb;
